/**
 * Roteamento por idioma.
 *
 * Antes o i18n era 100% client-side: a escolha ficava só no localStorage e
 * as três versões compartilhavam a mesma URL. Para um buscador existia UMA
 * página, em português — inglês e espanhol eram invisíveis, o que é o
 * oposto do que se quer com clientes hispanohablantes.
 *
 * Agora cada idioma tem URL própria:
 *
 *   pt →  /            /pixviewer        /pixrow
 *   en →  /en          /en/pixviewer     /en/pixrow
 *   es →  /es          /es/pixviewer     /es/pixrow
 *
 * O português fica na RAIZ, sem prefixo, de propósito: as URLs atuais já
 * estão indexadas e compartilhadas, e prefixá-las custaria o histórico de
 * SEO por nada.
 */

export const DEFAULT_LANG = 'pt';
export const LANGS = ['pt', 'en', 'es'];

/** Prefixo de URL de um idioma ('' para o padrão). */
export function langPrefix(lang) {
  return lang && lang !== DEFAULT_LANG && LANGS.includes(lang) ? `/${lang}` : '';
}

/**
 * Extrai o idioma do pathname e devolve também o caminho sem o prefixo.
 * `/en/pixrow` → { lang: 'en', rest: '/pixrow' }
 * `/pixrow`    → { lang: 'pt', rest: '/pixrow' }
 */
export function splitLangPath(pathname) {
  const m = /^\/(pt|en|es)(?=\/|$)/.exec(pathname || '/');
  if (!m) return { lang: DEFAULT_LANG, rest: pathname || '/' };
  const rest = pathname.slice(m[0].length) || '/';
  return { lang: m[1], rest };
}

/** Monta um caminho no idioma dado. `to('/pixrow', 'es')` → `/es/pixrow`. */
export function localizedPath(rest, lang) {
  const clean = rest === '/' ? '' : rest;
  return `${langPrefix(lang)}${clean}` || '/';
}

/** URL absoluta — usada nas tags hreflang/canonical do prerender. */
export function absoluteUrl(baseUrl, rest, lang) {
  return `${baseUrl}${localizedPath(rest, lang)}`;
}

/** Código BCP-47 para `<html lang>` e `og:locale`. */
export const HTML_LANG = { pt: 'pt-BR', en: 'en', es: 'es' };
export const OG_LOCALE = { pt: 'pt_BR', en: 'en_US', es: 'es_ES' };
